import React, { useState } from "react";
import { Form, Input, Select, Button, Row, Col, notification,message,TimePicker,InputNumber } from "antd";
import { post } from "../../../../api/post";
import { getAccessTokenApi } from "../../../../api/auth";

import "./AddVehiclesForm.scss";


export default function AddVehiclesForm(props) {
  const { setIsVisibleModal, setReloadVehicles } = props;
  const [vehicleData, setVehicleData] = useState({co2emissions: 0.0});
  //const { vehicleData, setVehicleData } = props;
  const { Option } = Select;
  //console.log('entro a add form')
  //console.log(vehicleData);
  const addVehicle = (event) => {
    //console.log('entro a add user form interno')
    event.preventDefault();

    if (
      !vehicleData.name ||
      !vehicleData.types ||
      !vehicleData.capacityitems ||
      !vehicleData.capacityweigh ||
      !vehicleData.speed ||
      !vehicleData.fixcost ||
      !vehicleData.kmcost ||
      !vehicleData.hourcost 
      // ||!vehicleData.co2emissions
    ) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios.",
      // });
      message.error("Todos los campos son obligatorios.")
    } else {
      //const accesToken = getAccessTokenApi();
      // if(!vehicleData.hourcost )setVehicleData({ ...vehicleData, co2emissions: 0.0 })
      // createVehicleAPI(vehicleData)
      post(vehicleData,'create-vehicle','create-vehicle','')
        .then((response) => {
          // notification["success"]({
          //   message: response,
          // });
          message.success('Vehicle created')
          setIsVisibleModal(false);
          setReloadVehicles(true);
          // setVehicleData({});
        })
        .catch((err) => {
          // notification["error"]({
          //   message: err.message,
          // });
          message.error(err.message)
        });
    }
    //console.log("CREARUSUARIO");
    //console.log(vehicleData);
  };
  return (
    <Form className="form-add" onSubmit={addVehicle}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={vehicleData.name}
              onChange={(e) =>
                setVehicleData({ ...vehicleData, name: e.target.value })
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Vehicle type"
              onChange={(e) => setVehicleData({ ...vehicleData, types: e })}
              value={vehicleData.types}
            >
              <Option value="bike">Bike</Option>
              <Option value="van">Van</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Capacity items'
              name='capacityitems'
              min={0}
              max={9999999}
              step={1}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, capacityitems: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Capacity weight'
              name='capacityweight'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, capacityweigh: e })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Speed'
              name='speed'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, speed: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Fix cost'
              name='fixcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, fixcost: e })}}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Km cost'
              name='kmcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, kmcost: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Hour cost'
              name='hourcost'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, hourcost: e })}}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='CO2 emissions'
              name='co2emissions'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setVehicleData({ ...vehicleData, co2emissions: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Button style={{
          backgroundColor:'white',
          width:'225px',
          borderWidth:'2px',
          fontSize:'15px',
          color:'rgb(35,148,212)',
          fontFamily:'report-bold',
        }} type="submit" htmlType="submit" className="btn-submit" onClick={addVehicle}>
              Crear Vehículo
            </Button>
          </Form.Item>
        </Col>
      </Row>
      
    </Form>
  );
}
